import {Button, Grid} from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import ButtonWithProgress from "../../../../../components/ui/buttons/button-with-progress/ButtonWithProgress";

const ConfirmActions = (props) => {
    return (
        <>
            <Grid container
                  justifyContent={"space-between"}
                  alignItems={"center"}>
                <Button variant={"outlined"}
                        color={"primary"}
                        onClick={props.handleConfirmModalCancelButton}>
                    Annulla
                </Button>

                <ButtonWithProgress variant="contained"
                                    loading={props.loading}
                                    color="primary"
                                    text={"Conferma"}
                                    handleClick={props.handleConfirmModalAcceptButton}/>
            </Grid>
        </>
    )
}

ConfirmActions.propTypes = {
    handleConfirmModalCancelButton: PropTypes.func.isRequired,
    handleConfirmModalAcceptButton: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
}

export default ConfirmActions
